export const MOBILE_NUMBER_REGEX = /^[6-9][0-9]{9}$/
export const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
export const NAME_REGEX = /^[a-zA-Z ]{2,254}$/
export const ID_REGEX = /^[a-zA-Z ]+@(zet)$/
export const PINCODE_REGEX = /^[1-8][0-9]{5}$/

export const PAN_REGEX = /(^([a-zA-Z]{5})([0-9]{4})([a-zA-Z]{1})$)/
